"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tlds = void 0;
var tlds = {
  eth: {
    supported: true
  },
  xyz: {
    supported: true
  },
  test: {
    supported: true
  },
  reverse: {
    supported: true
  },
  luxe: {
    supported: true
  }
};
exports.tlds = tlds;